// extracted by css-extract-rspack-plugin
export default {"baseBranchGroup":"PullRequestHeaderBranches-module__baseBranchGroup__MjaHD"};